class ZetaVoiceApi extends ZetaApi {
  #domain = window.location.href.includes('gocart-stg') ? "dev.voice.zetacx.net" : "voice.zetacx.net";
  #path;
  #paramsUtilObj = null;
  #siteId = window.location.href.includes('gocart-stg') ? "8b0ca311-c243-4e55-b3f4-ba948ceaf348" : "e8364463-3dea-4d1f-a9b4-0505e63ee50b"; //ZETA VOICEのサイトID
  #maxItemsPerRequest = 20; // unit_argsの登録上限数

  constructor() {
    super();
    this.#paramsUtilObj = new ParamsUtil();
  }

  /**
   * ZETA VOICE APIにリクエストを送信する
   * @returns {Promise<Object|undefined>} APIレスポンス
   */
  async request() {
    const params = this.#paramsUtilObj.makeQueryStrings();

    let url = `https://${this.#domain}/${this.#path}`;
    url += params ? `?${params}` : "";

    try {
      const response = await fetch(url, {
        method: "GET",
        mode: "cors",
        headers: {
          "Cache-Control": "no-cache"
        }
      });

      return await response.json();
    } catch (error) {
      console.error(`error: ${error}`);
    }
  }

  /**
   * APIエンドポイントを設定
   * @param {string} path APIエンドポイントのパス
   */
  set endPoint(path) {
    this.#path = path;
    super.endPoint = path;
  }

  initializeParams() {
    super.initializeParams();
    this.#paramsUtilObj.initializeParams();
  }

  /**
   * リクエストパラメータを追加・更新
   * @param {string} key パラメータのキー名
   * @param {string|number|Object} value パラメータの値
   */
  deleteInsertParam(key, value) {
    super.deleteInsertParam(key, value);
    this.#paramsUtilObj.deleteInsertParam(key, value);
  }

  /**
   * レビュー存在確認API(一括)
   * @param {string} siteId - ZETA VOICEのサイトID
   * @param {string} reviewer_fk - Shopifyの顧客ID（cusromer_id）
   * @param {string} unit_args - 商品ID(item_group_id)のJSON配列(最大20個)
   * @returns {Promise<Array|null>} レビュー存在確認結果
   */
  async bulkCheckReviewExists(siteId, reviewer_fk, unit_args) {
    try {
      this.endPoint = "api/bulkCheckReviewExists";
      this.initializeParams();
      this.deleteInsertParam("site_id", siteId);
      this.deleteInsertParam("reviewer_fk", reviewer_fk);
      this.deleteInsertParam("unit_args", unit_args);

      const response = await this.request();
      return response || null;
    } catch (error) {
      console.error('Fetch Error:', error);
      return null;
    }
  }

  /**
   * レビューボタンの非活性化
   * 購入履歴内の商品に対してレビュー存在確認を行い、レビュー済みの商品のレビューボタンを無効化
   * @param {number} customerId - Shopifyの顧客ID（cusromer_id）
   * @param {string} selector - 購入履歴の商品要素（data-item-idを持つ要素）を取得するCSSセレクタ
   * @returns {Promise<boolean|null>} レビュー存在確認結果
   */
  async activateReviewButton(customerId, selector) {
    try {
      const purchasedItems = document.querySelectorAll(selector);
      if (purchasedItems.length === 0) {
        return false;
      }
      const unit_args_objects = []; // APIに送信するパラメータ全件
      const chunks = []; // unit_argsの登録上限数(20個)ずつに分割した配列

      purchasedItems.forEach((item) => {
        const item_code = item.getAttribute('data-variant-id');
        if (item_code) {
          unit_args_objects.push({
            "item_code": item_code,
            "is_deleted": 0 // レビュー削除フラグ０：削除前のみ
          });
        }
      });

      for (let i = 0; i < unit_args_objects.length; i += this.#maxItemsPerRequest) {
        chunks.push(unit_args_objects.slice(i, i + this.#maxItemsPerRequest));
      }

      // unit_argsの登録上限数(20個)ごとにAPIを呼び出す
      for (const chunk of chunks) {
        const unit_args = JSON.stringify(chunk);
        const chunkResult = await this.bulkCheckReviewExists(this.#siteId, customerId, unit_args);

        if (chunkResult === null || !Array.isArray(chunkResult)) {
          continue;
        }
        // 各商品要素に対してレビュー存在確認の結果を反映
        for (const item of purchasedItems) {
          const variantId = item.getAttribute('data-variant-id');
          if (!variantId) {
            continue;
          }

          // result配列から該当する商品の情報を取得
          const reviewInfo = chunkResult.find(result => {
            return result.params?.item_code === variantId;
          });

          // レビューが存在する場合、レビューするボタンをdisabledにする
          if (reviewInfo && reviewInfo.exists === true) {
            //オンライン購入履歴側のidには末尾にorder.idが付与されているため、variantIdまでの前方一致で判定する
            const selector = `[id^="review-button-${variantId}"]`;
            let reviewButton = item.querySelector(selector);
            if (reviewButton) {
              reviewButton.disabled = true;
              reviewButton.classList.add("is-reviewed");
              reviewButton.textContent = "レビュー済";
            }
          }
        }
      }
      return true;
    } catch (error) {
      console.error('Error checking reviews:', error);
      return null;
    }
  }
}
